export default "__VITE_ASSET__DrFLHXIO__"